import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect, useLocation, useHistory } from 'react-router-dom'
import './CustomerRank.css'
import { addCustomerRank, updateCustomerRank } from '../../../actions/userActions/customerRankAction';
import BodyExtraSmallMedium from '../../designSystem/BodyExtraSmallMedium';
import Textarea from '../../designSystem/TextArea';
import BodyLargeMedium from '../../designSystem/BodyLargeMedium';
import customerrankicon from "../../../assets/images/customerrankicon.svg";
import closeModal from "../../../assets/images/closeModal.svg";
import TextField from '../../designSystem/TextField'
import { IconButton } from '@mui/material'
import { validateFields } from '../../../utils/Validations';
import { Check, X } from 'lucide-react';
import CancelButton from '../../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../../subComponents/buttons/PrimaryButton';
import { t } from '../../../locales/translate';

const AddCustomerRank = ({ onClose, editData, onSave }) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const initialValues = {
    rankName: '',
    rankDescription: '',
  }
  const [formValues, setFormValues] = useState(initialValues)
  const [formErrors, setFormErrors] = useState({})

  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);

  const handleSave = async (e) => {
    e.preventDefault();
    const errors = validateFields(formValues, 'rank');
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (editData) {
        await dispatch(updateCustomerRank(formValues));
      } else {
        await dispatch(addCustomerRank(formValues));
      }
      await onSave(formValues);
    }
  };
  return (
    <>

      <div className="dynamicmodal-overlay">
        <div className="dynamicmodal-container">
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
              <div className="icon">
                <img src={customerrankicon} alt="customerrankicon" />
              </div>
              <div className="text">
                <h2 className="modalheading">
                  {editData ? "Edit Customer Rank" : `${t("addCustomerRank")}`}
                </h2>
                <p className="modaldescription">
                  {t("addCustomerRankTip")}
                </p>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <TextField
                name="rankName"
                label={`${t("name")} *`}
                type='text'
                value={formValues.rankName}
                onChange={handletextChange}
                placeholder={t("name")}
                error={formErrors.rankName}
              />

              <Textarea
                name="rankDescription"
                label={`${t("description")} *`}
                placeholder={t("description")}
                value={formValues.rankDescription}
                onChange={handletextChange}
                error={formErrors.rankDescription}
              />
            </div>
            <div className="dynamicmodal-footer">
              <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "123px" : ""}
              />
            </div>
          </form>
        </div>
      </div>

    </>
  )
}

export default AddCustomerRank